export declare const ToScroll: any;
export declare const ToScrollPoint: any;
export default ToScroll;
export * from './src/scroll';
